module.exports = __webpack_public_path__ + "static/media/no-orders.e965e22a.svg";